import Common from '../common'
var Js = Common('productdetail')
export default {
	name: 'productdetail',
	mixins: [Js],
	components: {},
	data() {
		return {
      productData: {//存储的product的数据
      	role: 3,
      	title: '',
      	description: '',
      	price: '',
        f_price: '',
      	listorder: '', //排序
      	mainImg: [],
      	content: '',
      	bannerImg: [],
      	category_id: null,
      	shop_no: '',
      	description:'',
      	stock_type:1,
        stock:999,
        on_shelf: 1,
        home_show: 0,
        tj_type: 0,
        passage1: '',
        passage2: '',
        passage3: '',
        passage4: '',
        passage5: '',
        passage6: '',
        passage7: '',
        passage8: '',
        start_time: null,
        one_level: ''
      },
      originProductData: {//存储的product的数据
      	role: 3,
      	title: '',
      	description: '',
      	price: '',
      	f_price: '',
      	listorder: '', //排序
      	mainImg: [],
      	content: '',
      	bannerImg: [],
      	category_id: null,
      	shop_no: '',
      	description:'',
      	stock_type:1,
        stock:999,
        on_shelf: 1,
        home_show: 0,
        tj_type: 0,
        passage1: '',
        passage2: '',
        passage3: '',
        passage4: '',
        passage5: '',
        passage6: '',
        passage7: '',
        passage8: '',
        start_time: null,
        one_level: ''
      },
      originSkuData: {
				title: '',
				stock: 999,
				price: '',
				group_price:'',
				mainImg: [],
        stock_type:1
			},
      submitSku: {},
			searchItem: {},


			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

			type: 0, //0添加 1修改

      submitProduct:{
        stock:999
      },
			category_id:[],
			labelOptions: [],
			shopOptions: [],
			checkList: [],
			parentid: 0,
			skuLabelData: [], //sku类别
			skuTitle: '',
			titleId: 0,
			add: false,
			skuItemTit: '',
			skuData: [], //sku

			editsku: {
				title: '',
				stock: '',
				price: '',
				group_price:'',
				mainImg: [],
				one_level:'',
				two_level:''
			},
			edit: 0,
			mainData:{
        id:1,
      },
			productType:0,    //1.商城正常商品2.商城限时商品3.商城团购商品 4.民宿房间5.民宿商品 6.外卖商品
			behavior:0,
      product_id:'',
      hasSku: false,
      categorySearchItem:{
        type:3
      },
      fixProduct:{},
      fixSku:{},
      typeOptions: [
        {text: '是', value: 1},
        {text: '否', value: 0},
      ],
      shelfOptions: [
        {text: '上架', value: 1},
        {text: '下架', value: -1},
      ],
      passage1Options: [
        {text: '促销活动'},
        {text: '限时专享'},
        {text: '领券满减'},
      ],
		}

	},

	mounted() {
		const self = this;

		console.log('this.$route.params', this.$route.params)

    if(this.$route.params.product_id){
      self.product_id = this.$route.params.product_id;
    };

    if(this.$route.params.hasSku){
      self.hasSku = this.$route.params.hasSku;
    };
    if(this.$route.params.categorySearchItem){
      self.categorySearchItem = this.$route.params.categorySearchItem;
    };
    if(this.$route.params.fixProduct){
      self.fixProduct = this.$route.params.fixProduct;
    };
    if(this.$route.params.fixSku){
      self.fixSku = this.$route.params.fixSku;
    };

    self.type = this.$route.params.type;
		self.init();

	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

    backRoute(){
      const self = this;
     var fullPath = self.$route.fullPath;
     var tabList = self.$store.state.tabs.tabs;
     var routerRes = self.$$getBackRoute(tabList,fullPath);
     self.$store.commit('REMOVE_TABS', {
       fullPath:fullPath,
     });
     if(routerRes.backRes){
       self.$router.push(routerRes.backRes);
     }else{
       self.$router.push(routerRes.newRes);
     };
    },

		/**
		 * 初始化
		 */
		init() {
			const self = this;
      //获取商品类别
			self.initLabelData();

			if (self.product_id) {
				this.getProductData();
			};
      self.submitSku = self.$$cloneForm(self.originSkuData);
		},





    //获取类别
    async initLabelData(isNew,shop_no) {

    	const self = this;
    	const postData = {};
    	postData.token = self.$store.getters.getToken;
    	postData.searchItem = self.categorySearchItem;
    	var res = await self.$$api_labelGet({
    		data: postData
    	});
    	self.labelOptions = res.info.data;

    },




		//添加商品
		async productSubmit() {
			const self = this;

      var res = self.checkSubmitProduct();
      if(!res){
        return;
      };

			var postData = {};
			postData.token = self.$store.getters.getToken;
			postData.data = self.$$cloneForm(self.submitProduct);
      if(self.fixProduct){
        for(var key in self.fixProduct){
          postData.data[key] = self.fixProduct[key];
        };
      };
      if(!self.product_id){
        // postData.saveFunction = [{
        //   FuncName: 'generateQr',
        //   Param: {
        //     file : {
        //       behavior: 2
        //     },
        //     user_no: 'U910872296194660',
        //     res: {
        //       param: 'product_no',
        //     },//php码的格式
        //     config_id:1,
        //     thirdapp_id: 2,
        //     type: 1
        //   }
        // }]
        var res = await self.$$api_productAdd({
        	data: postData
        });
        if (res.solely_code == 100000) {
        	this.$message({
        		message: '添加成功',
        		type: 'success'
        	});
        	self.product_id = res.info.id;
        	self.getProductData();
        }
      }else{
        postData.searchItem = {};
        postData.searchItem.id = self.product_id;
        delete(postData.data.id);
        delete(postData.data.label);
        delete(postData.data.user_no);
        delete(postData.data.role);
        delete(postData.data.thirdapp_id);
        var res = await self.$$api_productUpdate({
        	data: postData
        });
        if (res.solely_code == 100000) {
        	this.$message({
        		message: '修改成功',
        		type: 'success'
        	});
        };
      };

		},

    checkSubmitProduct(){

      const self = this;
      console.log('checkSubmitProduct',self.submitProduct)
      if(self.product_id){
        if (self.submitProduct&&self.submitProduct.category_id=='') {
        	this.$message({
        		message: '请选择商品类别',
        		type: 'warning'
        	});
        	return false;
        };
      }else{
        if (!self.submitProduct.title || !self.submitProduct.price) {
        	this.$message({
        		message: '请完善商品名称和售价',
        		type: 'warning'
        	});
        	return false;
        };

        if (!self.submitProduct.category_id) {
        	this.$message({
        		message: '请选择商品类别',
        		type: 'warning'
        	});
        	return false;
        };
      };

      return true;
    },

    async getProductData() {

    	const self = this;
    	const postData = {};
    	postData.token = self.$store.getters.getToken;
    	postData.searchItem = {
        id:self.product_id
      };
    	var res = await self.$$api_productGet({
    		data: postData
    	});
    	self.productData = res.info.data[0];
      // self.productData.category_id = self.productData.category_id.split(',');   //多级类别
      self.productData.category_id = parseInt(self.productData.category_id);    //一级类别
      for(var key in self.originProductData){
        self.submitProduct[key] = self.$$cloneForm(self.productData[key]);
      }
      self.productData.passage1 = self.productData.passage1.split(',');   //多级类别
      self.productData.start_time = self.productData.start_time*1000;
      // self.initSkuLabelData()
    	// self.getSkuData();
    },

    async getSkuData() {
    	const self = this;
    	const postData = {};
    	postData.token = self.$store.getters.getToken;
    	postData.searchItem = {
    		product_id: self.product_id
    	}
    	postData.order = {
    		create_time: 'asc'
    	}
    	var res = await self.$$api_skuGet({
    		data: postData
    	});
    	self.skuData = res.info.data;
      self.submitSku = self.$$cloneForm(self.originSkuData);
    },



		clearPro() {
			const self = this;
      self.productData = self.$$cloneForm(self.originProductData);
      self.submitProduct = {};
			self.product_id = '';
			self.mainData = {};
			self.skuLabelData = [];
			self.skuData = [];
      self.submitSku = self.$$cloneForm(self.originSkuData);
		},

		async skuSubmit() {
			const self = this;

      if(!self.product_id){
        self.$message({
        	message: '请先添加product',
        	type: 'warning'
        });
        return;
      };
      var res = self.checkSubmitSku();
      if(!res){
        return;
      };
      const postData = {
      	token: self.$store.getters.getToken,
      	data: self.$$cloneForm(self.submitSku),
      };
      if(self.submitSku.id){
        postData.searchItem = {
          id:self.submitSku.id
        };
        delete(postData.data.id);
        delete(postData.data.product);
        delete(postData.data.user_no);
        delete(postData.data.role);
        delete(postData.data.thirdapp_id);
        var res = await self.$$api_skuUpdate({
        	data: postData
        });
      }else{
        postData.data.product_id = self.productData['id'];
        postData.data.product_no = self.productData['product_no'];

        if(self.fixSku){
          for(var key in self.fixSku){
            postData.data[key] = self.fixSku[key];
          };
        };
        var res = await self.$$api_skuAdd({
        	data: postData
        });
      };
      console.log('res',res)
      if (res.solely_code == 100000) {
      	self.$message({
      		message: self.submitSku.id?'修改成功':'添加成功',
      		type: 'success'
      	});
        self.getSkuData();
      }else{
        self.$message({
        	message: '操作失败',
        	type: 'warn'
        });
      };

		},



    checkSubmitSku(){

      const self = this;

      if(!self.submitSku.id){
        if (!self.submitSku.title || !self.submitSku.price || !self.submitSku.stock || self.submitSku.mainImg
        	.length <= 0) {
        	self.$message({
        		message: '请完善商品SKU信息',
        		type: 'warning'
        	});
        	return false;
        }
      };
      return true;
    },


    async deleteSku(item) {
    	const self = this;
    	self.$confirm('此操作将删除该商品sku, 是否继续?', '提示', {
    		confirmButtonText: '确定',
    		cancelButtonText: '取消',
    		type: 'warning'
    	}).then(async () => {
    		var data = {
    			status: -1
    		};
    		var res = await self.$$api_skuUpdate({
          data:{
            searchItem:{
              id:item.id
            },
            data: {status:-1}
          }
    		});
        if (res.solely_code == 100000) {
        	self.$message({
        		message: '删除成功',
        		type: 'success'
        	});
          self.getSkuData();
        }else{
          self.$message({
          	message: '删除失败',
          	type: 'warn'
          });
        };
    	}).catch(() => {
    		self.$message({
    			type: 'info',
    			message: '取消删除'
    		});
    	});
    },

    //分水岭

		chooseSku(item) {
			const self = this;
			self.submitSku.id = item.id;
			for(var key in self.originSkuData){
			  self.submitSku[key] = self.$$cloneForm(item[key]);
			}
		},

		editSku(item) {
			const self = this;
			self.$confirm('此操作将修改该商品sku信息, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				self.updateSku(item, self.editsku, 1);
			}).catch(() => {
				self.$message({
					type: 'info',
					message: '取消修改'
				});
			});
		},



		async initSkuLabelData(isNew) {
			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			postData.searchItem = {
				type: ['in', [5, 6]],
				relation_id: self.product_id
			}
			postData.order = {
				create_time: 'asc'
			}
			var res = await self.$$api_labelGet({
				data: postData
			});
			self.skuLabelData = res.info.data;
		},

		async addSkuLabel(type, item) {
			const self = this;
			const postData = {};
			if ((!self.skuTitle && type == 5) || (!self.skuItemTit && type == 6)) {
				self.$message({
					message: '请填写名称',
					type: 'warning'
				});
				return;
			}
			postData.token = self.$store.getters.getToken;
			postData.data = {
				type: type,
				relation_id: self.product_id
			}
			if (type == 5) {
				postData.data.title = self.skuTitle
			} else {
				postData.data.title = self.skuItemTit;
				postData.data.parentid = item.id;
			}
			var res = await self.$$api_labelAdd({
				data: postData
			});
			self.skuTitle = '';
			self.skuItemTit = '';
			self.itemId = 0;
			self.add = false;
			self.initSkuData();
		},

		async updateSkuLabel(item, type) {
			const self = this;
			const postData = {};
			if (!item.title) {
				self.$message({
					message: '名称不可为空',
					type: 'warning'
				});
				return;
			}
			postData.token = self.$store.getters.getToken;
			postData.data = {
				title: item.title
			}
			postData.searchItem = {
				id: item.id
			}
			var res = await self.$$api_labelUpdate({
				data: postData
			});
			self.titleId = 0;
			self.initSkuData();
		},

		deleteCon(id, type) {
			const self = this;
			if (type) {
				var title = '此操作将删除该类别及子集类别, 是否继续?';
			} else {
				var title = '此操作将删除该类别, 是否继续?'
			}
			self.$confirm(title, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				self.deleteSkuLabel(id, type);
			}).catch(() => {
				self.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		async deleteSkuLabel(id, type) {
			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			postData.data = {
				status: -1
			}

			if (type) {
				postData.searchItem = {
					parentid: id
				}
				postData.saveAfter = [{
					tableName: 'Label',
					FuncName: 'update',
					data: {
						status: -1
					},
					searchItem: {
						id: id
					}
				}]
			} else {
				postData.searchItem = {
					id: id
				}
			}
			var res = await self.$$api_labelUpdate({
				data: postData
			});
			self.$message({
				type: 'success',
				message: '删除成功!'
			});
			self.titleId = 0;
			self.initSkuData();
		},
	},


}



// WEBPACK FOOTER //
// ./src/views/detail/productdetail.js